// framework/src/common/schemas/collections/secrets.js
//
// UI-facing schema for the SecretsManager component.
// Represents the metadata view of a secret — value is write-only (never returned for display).

import { z } from 'zod';

const SecretDefinitionSchema = z.object({
    _id:         z.string().optional().describe('MongoDB ObjectId string.'),

    scope:       z.enum(['subscription', 'project', 'agent'])
                  .describe('subscription = all agents in tenant, project = project-scoped, agent = private to one agent.'),

    projectId:   z.string().optional().nullable()
                  .describe('Required for scope:project.'),

    agentName:   z.string().optional().nullable()
                  .describe('Required for scope:agent.'),

    key:         z.string().min(1)
                  .describe("Machine-readable key name. E.g. 'stripe_api_key'."),

    label:       z.string().optional().nullable()
                  .describe('Human display name. E.g. "Stripe API Key".'),

    // value is write-only — only sent on create/update, never returned in list/get
    value:       z.string().optional()
                  .describe('Secret value. Write-only — encrypted server-side, never shown in UI.'),

    description: z.string().optional().nullable()
                  .describe('What this secret is for.'),

    createdAt:   z.coerce.date().optional(),
    updatedAt:   z.coerce.date().optional(),
});

export default SecretDefinitionSchema;